import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../utils/theme';

const LanguageSelector = () => {
  const { t, i18n } = useTranslation('navbar');
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const dropdownRef = useRef(null);

  // Currently, we only support English
  const languages = [
    { code: 'en', name: t('languageSelector.english') }
  ];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setShowLanguageMenu(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLanguageMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setShowLanguageMenu(!showLanguageMenu)}
        className={theme.nav.button.base + ' ' + theme.nav.button.secondary + ' flex items-center gap-2'}
        aria-label={t('languageSelector.language')}
      >
        <span>{i18n.language === 'en' ? '🇺🇸' : '🇺🇸'}</span>
        <span className="hidden md:inline">{t('languageSelector.english')}</span>
        <svg className={`w-4 h-4 transform transition-transform ${showLanguageMenu ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {showLanguageMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
          <div className="px-4 py-2 text-sm text-gray-500 border-b border-gray-100">
            {t('languageSelector.language')}
          </div>
          {languages.map(language => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className={`w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 ${
                i18n.language === language.code ? 'bg-gray-50 font-medium' : ''
              }`}
            >
              {language.code === 'en' ? '🇺🇸' : '🇺🇸'} {language.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;